import { render, staticRenderFns } from "./facilityParams.vue?vue&type=template&id=3fb511b5&scoped=true"
import script from "./facilityParams.vue?vue&type=script&lang=js"
export * from "./facilityParams.vue?vue&type=script&lang=js"
import style0 from "./facilityParams.vue?vue&type=style&index=0&id=3fb511b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb511b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fb511b5')) {
      api.createRecord('3fb511b5', component.options)
    } else {
      api.reload('3fb511b5', component.options)
    }
    module.hot.accept("./facilityParams.vue?vue&type=template&id=3fb511b5&scoped=true", function () {
      api.rerender('3fb511b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/facilityParams.vue"
export default component.exports